import cx from "classnames";
import { useTranslation } from "react-i18next";
import styles from "./Detail.module.css";

const Detail = ({ className = "", open = null, label = "-", value = "-" }) => {
    const { i18n } = useTranslation();
    // console.log(value);

    const formattedValue = Array.isArray(value)
        ? value.map(item => i18n.language === "en" ? item.nameEn : item.name).join(', ')
        : (typeof value === 'object' && value !== null)
            ? i18n.language === "en" ? value.nameEn : value.name
            : value;

    return (
        open != null ? (
            <div className={cx(styles.container, "info__container", className)}>
                <p className={cx("info__value", styles.value)}>{label}:</p>
                <label
                    className={cx("info__label", styles.label)}
                    style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "250px" }}
                    title={formattedValue}
                >
                    {formattedValue}
                </label>        </div>
        ) : null
    );
};

export default Detail;
